// Styles for __name__ go here.
import { baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const { color, font } = baseVariables;

export const StyledNavigationDropdown = styled.ul`
  box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
  border-radius: 0 0 ${toRem(12)} ${toRem(12)};
  padding: ${toRem(24)};
  list-style: none;
  position: absolute;
  background: ${color.base20};
  z-index: 2;
  width: ${toRem(375)};
  overflow: hidden;
  margin: 0;
`;

export const StyledNavigationDropdownItem = styled.li`
  a {
    position: relative;
    min-height: ${toRem(40)};
    display: flex;
    align-items: center;
    text-decoration: none;
    font-family: ${baseVariables.font.fontSwiss};
    font-size: ${toRem(14)};
    font-weight: ${baseVariables.font.fontWeightRegular};
    line-height: ${toRem(21)};
    color: ${color.neutral40};
    border-radius: ${toRem(8)};
    padding: ${toRem(9)} 0 ${toRem(10)};
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: -${toRem(8)};
      right: -${toRem(8)};
      background: ${color.neutral10};
      border-radius: ${toRem(8)};
      opacity: 0;
      z-index: -1;
    }

    &:hover {
      color: ${color.base10};
      font-weight: ${font.fontWeightRegular};
      &::before {
        opacity: 1;
      }
    }
  }

  &.selected {
    a {
      color: ${color.base10};
    }
  }
`;
